import { PropTypes } from "prop-types"

const AccessibilityStatusMessage = ({ children }) => (
  <div className="oj-accessibility-status-message" role="alert" aria-atomic="true">
    {children}
  </div>
)

AccessibilityStatusMessage.propTypes = {
  children: PropTypes.node
}

export default AccessibilityStatusMessage
